import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';
import Accounts from './containers/Accounts/index.ts';

export const POST_CRM = {
  Helmet: lazy(() => import('./components/Helmet.tsx')),
  Accounts,
  ContactForm: lazy(() => import('./containers/Contacts/containers/ContactForm/index.tsx')),
  AccountFormRenderer: lazy(() => import('./components/AccountFormRenderer.tsx')),
  Contacts: lazy(() => import('./containers/Contacts/index.tsx')),
  ContactHistory: lazyNamed(() => import('./containers/Contacts/containers/History/index.tsx'), 'History'),
};

export { ContactFormSearchParams } from './types.ts';
